var _defs, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWa({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 92.09,
    height: 92.09,
    viewBox: "0 0 92.09 92.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 46.04,
    y1: 92.09,
    x2: 46.04,
    gradientTransform: "translate(24.32 -15.34) rotate(25.51)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#23cf43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5ffb7d"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 46.04,
    cy: 46.04,
    r: 46.04,
    transform: "translate(-15.34 24.32) rotate(-25.51)",
    fill: "url(#a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.66,23.64A30.42,30.42,0,0,0,20.79,60.33L16.47,76.09,32.6,71.86a30.38,30.38,0,0,0,14.53,3.7h0A30.42,30.42,0,0,0,68.66,23.64ZM47.15,70.42h0A25.25,25.25,0,0,1,34.27,66.9l-.92-.55-9.57,2.51,2.55-9.32-.6-1A25.29,25.29,0,1,1,47.15,70.42ZM61,51.5h0c.76.38,1.27.57,1.46.88A6.39,6.39,0,0,1,62,56c-.64,1.77-3.67,3.39-5.13,3.61a10.48,10.48,0,0,1-4.79-.3,44.41,44.41,0,0,1-4.33-1.6c-7.63-3.29-12.61-11-13-11.48s-3.1-4.12-3.1-7.86A8.5,8.5,0,0,1,34.35,32a2.8,2.8,0,0,1,2-.95c.5,0,1,0,1.45,0s1.1-.17,1.71,1.31,2.16,5.26,2.35,5.64A1.41,1.41,0,0,1,42,39.39a5.16,5.16,0,0,1-.76,1.27c-.38.44-.8,1-1.14,1.33s-.78.79-.33,1.55A22.73,22.73,0,0,0,44,48.8a20.67,20.67,0,0,0,6.11,3.77c.76.38,1.2.32,1.64-.19s1.9-2.22,2.41-3,1-.63,1.71-.38S60.25,51.12,61,51.5Z",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWa);
export default __webpack_public_path__ + "static/media/wa.e3c8056f2ef74db8a5e04674acac2333.svg";
export { ForwardRef as ReactComponent };